import { Grid } from "@mui/material";
import React from "react";
import { useAuth } from "../../../../../hooks";
import QTDetailsImageWithLabelSection from "../../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";

const AdminUserDetailsTopCardSection = ({
  adminUserDetails,
  setAdminUserDetails,
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
  newPassword,
  setNewPassword,
}) => {
  const { currentUser } = useAuth();

  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"Photo"}
          image={adminUserDetails?.photoUrl}
          // image={images.tableDummyImage}
          handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          editEnabled={editEnabled}
          details={adminUserDetails}
          setDetails={setAdminUserDetails}
          uploadImage={uploadImage}
          setUploadImage={setUploadImage}
        />
        {/*First Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"First Name"}
          value={adminUserDetails.firstName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAdminUserDetails({
              ...adminUserDetails,
              firstName: e.target.value,
            })
          }
        />
        {/*Last Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Last Name"}
          value={adminUserDetails.lastName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAdminUserDetails({
              ...adminUserDetails,
              lastName: e.target.value,
            })
          }
        />
        {/*Email section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Email"}
          value={adminUserDetails.email}
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setAdminUserDetails({
              ...adminUserDetails,
              email: e.target.value,
            })
          }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Account Status"}
          value={adminUserDetails.status}
          disabled={true}
          // editEnabled={editEnabled}
          editEnabled={
            editEnabled && currentUser?.role === "super"
              ? editEnabled
              : currentUser?.role === "manager" &&
                (adminUserDetails?.role === "standard" ||
                  adminUserDetails?.role === "moderator")
              ? editEnabled
              : false
          }
          select={true}
          dropdownValues={["active", "inactive", "invited"]}
          onChange={(e) =>
            setAdminUserDetails({
              ...adminUserDetails,
              status: e.target.value,
            })
          }
        />
        {/*username section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Username"}
          value={adminUserDetails.userName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAdminUserDetails({
              ...adminUserDetails,
              userName: e.target.value,
            })
          }
        />
        {/*Role section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Role"}
          value={adminUserDetails.role}
          disabled={true}
          // editEnabled={editEnabled}
          editEnabled={
            editEnabled && currentUser?.role === "super"
              ? editEnabled
              : currentUser?.role === "manager" &&
                (adminUserDetails?.role === "standard" ||
                  adminUserDetails?.role === "moderator")
              ? editEnabled
              : false
          }
          select={true}
          dropdownValues={
            currentUser?.role === "super"
              ? ["super", "manager", "standard", "moderator"]
              : currentUser?.role === "manager" &&
                (adminUserDetails?.role === "standard" ||
                  adminUserDetails?.role === "moderator")
              ? ["standard", "moderator"]
              : []
          }
          onChange={(e) =>
            setAdminUserDetails({
              ...adminUserDetails,
              role: e.target.value,
            })
          }
        />
        {/*password section*/}
        {currentUser?.role === "super" ? (
          <QTDetailsTextFieldWithLabelSection
            label={"Password"}
            name="New Password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            disabled={true}
            editEnabled={editEnabled}
            // onChange={(e) =>
            //   setAdminUserDetails({
            //     ...adminUserDetails,
            //     firstName: e.target.value,
            //   })
            // }
          />
        ) : undefined}
      </Grid>
    </Grid>
  );
};

export default AdminUserDetailsTopCardSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
};
